import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCircleCheck,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';

import { LoginSessionResponse } from '../../types/login-session-response';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { BffService } from '../../services/bff.service';

import { LoadingComponent } from '../loading/loading.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FontAwesomeModule, LoadingComponent],
  templateUrl: 'login.component.html',
})
export class LoginSuccessComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly bffService = inject(BffService);

  errorStatus = signal<number | null>(null);
  sessionExpiration = signal<string | null>(null);

  faCircleCheck = faCircleCheck;
  faTriangleExclamation = faTriangleExclamation;

  ngOnInit(): void {
    this.oidcSecurityService
      .getAuthenticationResult()
      .subscribe((authResult) => {
        if (authResult?.access_token) {
          this.bffService.verifyLogin(authResult.access_token).subscribe({
            error: (err) => {
                this.errorStatus.set(err.status)
            },
            next: (response: LoginSessionResponse) =>
              this.sessionExpiration.set(response.sessionExpiration),
          });

          this.oidcSecurityService
            .revokeAccessToken(authResult.access_token)
            .subscribe(() => {
              this.oidcSecurityService.logoffLocal();
            });
        } else {
          this.errorStatus.set(404);
        }
      });
  }
}
